// extracted by mini-css-extract-plugin
module.exports = {"container":"ConnectionHeader_container__1ZVoB","status":"ConnectionHeader_status__2qiES"};